import { useEffect, useState } from 'react';
import { PageNames } from '../../../../backend-wrapper/backend-wrapper';
import { IconName, SvgIcon } from '../../../../svg-icon/svg-icon';
import './nav-item.scss';

type NavItemProps = {
	displayName: string;
	icon: IconName;
	url: PageNames;
	color?: string;
};

export const NavItem = (props: NavItemProps) => {
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		setIsActive(window.location.search === `?page=${props.url}`);
	}, []);

	const clickNavigate = () => {
		window.location.href = `/wp-admin/admin.php?page=${props.url}`;
	};

	return (
		<button className={'nav-item ' + (isActive ? 'active' : '')} onClick={clickNavigate}>
			<SvgIcon name={props.icon} size={30} color={props.color} />
			<span className='nav-item-name'>{props.displayName}</span>
		</button>
	);
};
